import { render, staticRenderFns } from "./TooltipWindow.vue?vue&type=template&id=cb4a42d6&scoped=true"
var script = {}
import style0 from "./TooltipWindow.scss?vue&type=style&index=0&id=cb4a42d6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4a42d6",
  null
  
)

export default component.exports